export const LOCALES = ['fr', 'en', 'de', 'fi', 'es', 'it', 'pt', 'nl', 'ja', 'ko', 'zh_Hans', 'zh_Hant']
